import React from "react";

import useMediaQuery from "@mui/material/useMediaQuery";

import { ExhibitionScreenWithRiver } from "./ExhibitionScreenWithRiver";
import { ExhibitionScreenWithoutRiver } from "./ExhibitionScreenWithoutRiver";

//a box that located at the given position of a 3x3 grid

export function ExhibitionScreen(props) {
  const matches = useMediaQuery("(min-width:900px)");
  //aspect ratio landscape
  const isLandscape = useMediaQuery("(min-aspect-ratio: 1/1)");

  return matches && isLandscape ? (
    <ExhibitionScreenWithRiver {...props} />
  ) : (
    <ExhibitionScreenWithoutRiver {...props} />
  );
}
